import BuildIcon from "@material-ui/icons/Build";
import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { Configuration } from "./Configuration";
import { Vehicle } from "./modules/vehicles/index";
import { Yard } from "./modules/yards/index";
import { PaymentTypes } from "./modules/payment-types/index";
import { Warehouse } from "./modules/warehouse";
import { Inventory } from "./modules/inventory";
import { FileCompression } from "./modules/file-compression";
import { ApprovalUsers } from "./modules/approval-users";
import { Terminal } from "./modules/terminal";

export const ConfigurationRoute: IRoute = {
  title: "Configurations",
  path: "/configurations",
  icon: BuildIcon,
  component: Configuration,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: Vehicle, path: "/vehicles", title: "Vehicle" },
    { icon: InfoIcon, component: Yard, path: "/yards", title: "Yards" },
    {
      icon: InfoIcon,
      component: PaymentTypes,
      path: "/payment-types",
      title: "Payments",
    },
    {
      icon: InfoIcon,
      component: Warehouse,
      path: "/warehouse",
      title: "Warehouse",
    },
    {
      icon: InfoIcon,
      component: Inventory,
      path: "/inventory",
      title: "Inventory",
    },
    {
      icon: InfoIcon,
      component: ApprovalUsers,
      path: "/approval-user",
      title: "Approval Users",
    },
    {
      icon: InfoIcon,
      component: FileCompression,
      path: "/file-compression",
      title: "File Compression",
    },
    {
      icon: InfoIcon,
      component: Terminal,
      path: "/terminals",
      title: "Terminals",
    },
  ],
};
